import { Outlet } from 'react-router-dom';
import HeroSlider from '../shared/HeroSlider';
import QualifyStrip from '../shared/QualifyStrip';
import { HERO_SLIDES, type HeroSlide } from '../../data/siteContent';
import { useWebsiteContent } from '../../contexts/WebsiteContentContext';

export default function PageLayout() {
  const cms = useWebsiteContent();
  const slides: HeroSlide[] = cms?.heroSlides ?? HERO_SLIDES;

  return (
    <>
      <HeroSlider slides={slides} defaultDuration={cms?.heroSlideDefaultDuration} />
      {/* "SEE IF I QUALIFY" band — on every hero page, directly under the slider */}
      <QualifyStrip />
      <Outlet />
    </>
  );
}
